import { State, StudioDialogTypes } from './types';

const getters = {
  getOpenedDialog(state: State): StudioDialogTypes | undefined {
    return state.openDialog;
  },
  getIsToggleOpen(state: State): boolean {
    return state.isToggelOpen;
  },
  getOpenedDialogData<T extends {}>(state: State): T | undefined {
    return state.data as T;
  }
};

export default getters;
